import { consultationNotesClient } from '@/api/consultations/consultationNotesHistoryClient';
import { QueryKey } from '@/data/query';

export const useGetConsultationNotesHistory = (consultationId: number) => {
  const queryClient = consultationNotesClient();
  const queryKey = [QueryKey.ConsultationNotes, consultationId];

  const data = queryClient.getByConsultationId.useQuery({
    queryKey,
    queryData: {
      params: { consultationId },
    },
    enabled: true,
    refetchOnMount: 'always',
  });

  return data;
};
